import { render, staticRenderFns } from "./ProductCombobox.vue?vue&type=template&id=6215c6ec&"
import script from "./ProductCombobox.vue?vue&type=script&lang=ts&"
export * from "./ProductCombobox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports